import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcaseOnWheels = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 7V2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5h1.34C17.8 7 19 8.19 19 9.66v8.69c0 1.47-1.19 2.66-2.66 2.66V21H16v1c0 .55-.45 1-1 1s-1-.45-1-1v-1h-4v1c0 .55-.45 1-1 1s-1-.45-1-1v-1h-.34C6.2 21 5 19.81 5 18.34V9.66C5 8.19 6.19 7 7.66 7zm4 0V3h-2v4zM7 9.66c0-.37.3-.66.66-.66h8.68c.37 0 .66.3.66.66v8.69c0 .37-.3.66-.66.66H7.66a.66.66 0 0 1-.66-.66z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuitcaseOnWheels;
